module.exports = __webpack_public_path__ + "static/media/ptLogoSmallImg.cd1abd17.png";